// ABOUTME: Content wrapper for echeck views that shows content inline on desktop
// ABOUTME: and inside a TabViewBody Drawer on mobile/tablet

import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import TabViewBody from "../../../../components/theme/TabView3/TabViewBody";
import EcheckMobileHeader from "./EcheckMobileHeader";

const EcheckContentWrapper = (props) => (
    <>
        {/* Desktop */}
        <Box
            sx={{
                flex:1,
                display:"flex",
                flexDirection:"column",
                overflow:"hidden",
                "@media screen and (max-width: 63.9375em)": {
                    display: "none"
                }
            }}
        >
            {props.children}
        </Box>
        {/* Mobile - TabViewBody handles Drawer via portal */}
        <Box sx={{ display: "none" }}>
            <TabViewBody
                breakPoint="tablet"
                customHeader={
                    <EcheckMobileHeader
                        onBack={() => props.setOpen(false)}
                        incData={props.incData}
                        setIncData={props.setIncData}
                        setHighlightColor={props.setHighlightColor}
                        refetchJobs={props.refetchJobs}
                        selectedWorkSpace={props.selectedWorkSpace}
                    />
                }
                subpanelActive={props.open}
                setSubpanelActive={props.setOpen}
                subpanelDisplayOverwrite
            >
                {props.children}
            </TabViewBody>
        </Box>
    </>
);

export default EcheckContentWrapper;
